import ContentSlider from "./ContentSlider";

jQuery(function() {
    //get the element found on the page
    var $splitContentSliders = jQuery('[data-contentslider]');
    //set up array of sliders
    window.splitContentSliders = window.splitContentSliders || [];

    //primary method to set up sliders from dom
    var setUpSliders = function($sliders) {

        for (var i=0;i< $sliders.length;i+=1) {
            var item = $sliders.get(i);
            var $element = jQuery(item);
            window.splitContentSliders.push(new ContentSlider($element));
        }
    };

    //run set up
    setUpSliders($splitContentSliders);
});

